// extracted by mini-css-extract-plugin
export var card = "aboutCard-module--card--XbYU3";
export var link = "aboutCard-module--link--3cSoy";
export var contentWrapper = "aboutCard-module--contentWrapper--iLJmc";
export var logoWrapper = "aboutCard-module--logoWrapper--QD-IC";
export var logo = "aboutCard-module--logo--21rK-";
export var description = "aboutCard-module--description--VfWh0";